
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nos-dossiers",
      function () {
        return require("private-next-pages/nos-dossiers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nos-dossiers"])
      });
    }
  